import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import customerApi from '../../../services/apiServices/customerApi';
import orderApi from '../../../services/apiServices/orderApi';
import './PersonPage.css';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../../services/redux/loadingSlice';
import { toast } from 'react-toastify';
import configService from '../../../services/configService';
import { maskCEP, maskDocument } from '../../../components/masks/masks';
import { useNavigate } from "react-router-dom";
import { putDateOnPattern } from '../../../utils/functions';
import EyeIcon from '../../../components/icons/EyeIcon';
import Pagination from '../../../components/common/Pagination/Pagination';

const PersonPage = () => {
    const navigate = useNavigate();
    const { code } = useParams();
    const dispatch = useDispatch();
    const [customer, setCustomer] = useState(undefined);
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItens, setTotalItens] = useState(0);
    const quantity = configService.getDefaultNumberOfItemsTable(); 
    const orderBy = "Created:Desc";

    useEffect(() => {
        const fetchCustomer =  async () => {
            dispatch(setLoading(true));
            try {
                const response = await customerApi.getCustomerByCode(code, {include: 'User,User.Address.City,CustomerType'});
                setCustomer(response);
            } catch (error) {
                toast.error('Erro ao buscar os dados de perfil.');
            } finally {
                dispatch(setLoading(false));
            }
        }

        const fetchOrders = async () => {
            dispatch(setLoading(true));
            try {
                const response = await orderApi.getOrdersPaginated({ page, quantity, orderBy, personId: code, include: "Customer.User" });
                setItems(response.Results);
                setTotalPages(response.TotalPages);
                setTotalItens(response.TotalCount);
            } catch (error) {
                toast.error('Erro ao buscar os pedidos.');
            } finally {
                dispatch(setLoading(false));
            }
        };

        fetchOrders();

        fetchCustomer();

    }, [code, page, quantity, dispatch]);

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    const openItem = (code) => {
        navigate(`${code}`);
    }

    if(customer === undefined)
        return(<div className='customer-container'>Carregando</div>)
    else
    return (
    <div className="container-admin-page">
        <div className='space-double-bottom'>
            <h1>Detalhes do {customer.CustomerType.Id === configService.getClientPersonTypeCode() ? 'Cliente' : 'Usuário'}</h1>
        
            <div>
                <div className="box space-double-bottom">
                    <div>
                        <h2>Informações Básicas</h2>
                    </div>
                    <div className="flex-row gap-triple-default">
                        <div className="info-group">
                            <p><strong>Id:</strong> {customer.Id}</p>
                            <p><strong>Nome:</strong> {customer.User.Name}</p>
                            <p><strong>Email:</strong> {customer.User.Email}</p>
                            <p><strong>Documento:</strong> {customer.User.Document1 ? maskDocument(customer.User.Document1) : 'Não informado'}</p>
                            <p><strong>Tipo de Pessoa:</strong> {customer?.PersonType ? configService.getPersonType(customer?.PersonType) : 'Não informado'}</p>
                        </div>
                        <div className="info-group">
                            <p><strong>Tipo:</strong> {customer.CustomerType.Id === parseInt(configService.getClientPersonTypeCode()) ? 'Cliente' : 'Administrador'}</p>
                            <p><strong>Guid:</strong> {customer.User.GuidCustomer}</p>
                            <p><strong>Criado:</strong> {putDateOnPattern(customer.User.Created)}</p>
                            <p><strong>Atualizado:</strong> {putDateOnPattern(customer.User.Updated)}</p>
                            <p><strong>Status:</strong> <span className={customer.User.IsActive === 1 ? 'item-active' : 'item-inactive'}>{customer.User.IsActive === 1 ? 'Ativo' : 'Desativado'}</span></p>
                        </div>
                    </div>
                </div>

                {
                    customer.User.Address.length > 0 && 
                    <div className="box">
                        <div>
                            <h2>Endereço</h2>
                        </div>
                        <div className="info-group">
                            <p><strong>Endereço:</strong> {customer.User.Address[0].StStreet}, {customer.User.Address[0].NrBuildIngsite}</p>
                            <p><strong>Bairro:</strong> {customer.User.Address[0].StNeighborhood}</p>
                            <p><strong>Complemento:</strong> {customer.User.Address[0].StComplement || 'Não informado'}</p>
                            <p><strong>Cidade:</strong> {customer.User.Address[0].City.Name} - {customer.User.Address[0].City.State}</p>
                            <p><strong>CEP:</strong> {maskCEP(customer.User.Address[0].StZipCode)}</p>
                        </div>
                    </div>
                }
            </div>

        </div>

        {
            customer.CustomerType.Id === parseInt(configService.getClientPersonTypeCode()) && 
            <div>
                <h1>Pedidos</h1>

                <div className='container-admin-page-table div-with-border'>
                    <table className="admin-table">
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Nº Pedido</th>
                                <th>Valor</th>
                                <th>Cliente</th>
                                <th>Status</th>
                                <th>Criado</th>
                                <th>Atualizado</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                        {items.map((item) => (
                            <tr key={item.Id}>
                                <td><span className='option-link' onClick={() => openItem(`${item.Id}` + item.Id)}>{item.Id}</span></td>
                                <td><span className='option-link' onClick={() => openItem(`${item.Id}`)}>{item.NrOrder}</span></td>
                                <td><span className='option-link' onClick={() => openItem(`${item.Id}`)}>{item.VlnetPrice}</span></td>
                                <td><span className='option-link' onClick={() => openItem(`${item.Id}`)}>{item.Customer.User.Email}</span></td>
                                <td><span className='option-link' onClick={() => openItem(`${item.Id}`)}>{configService.getOrderDescription(item.OrderStatusId)}</span></td>
                                <td><span className='option-link' onClick={() => openItem(`${item.Id}`)}>{putDateOnPattern(item.Created)}</span></td>
                                <td><span className='option-link' onClick={() => openItem(`${item.Id}`)}>{putDateOnPattern(item.Updated)}</span></td>
                                <td><span className='option-link' onClick={() => openItem(`/pedidos/${item.Id}`)}><EyeIcon/></span></td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <sub>Total de Pedidos: {totalItens}</sub>
                    <Pagination page={page} totalPages={totalPages} onPageChange={handlePageChange} />
                </div>
            </div>
        }

    </div>
  );
};

export default PersonPage;
